module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Align-left-dbcb2174b56e0752d5852d8565e31adb.svg";